export const getEndDate = (startDate: Date, lengthInMinutes: number): Date =>
  new Date(+startDate + lengthInMinutes * 60000)
